var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", { staticClass: "modal-title" }, [
        _vm._v(
          " " + _vm._s(_vm.mode === "edit" ? "Update" : "Add") + " Location"
        )
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _c(
              "div",
              [
                _c(
                  "b-form-group",
                  {
                    class: {
                      "error-input": _vm.$v.company_location.name.$error
                    }
                  },
                  [
                    _c("label", { attrs: { for: "text1" } }, [
                      _vm._v(" Name ")
                    ]),
                    _vm._v(" "),
                    _c("j-input", {
                      attrs: { id: "text1", placeholder: "Name" },
                      model: {
                        value: _vm.$v.company_location.name.$model,
                        callback: function($$v) {
                          _vm.$set(_vm.$v.company_location.name, "$model", $$v)
                        },
                        expression: "$v.company_location.name.$model"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  {
                    class: {
                      "error-input": _vm.$v.company_location.code.$error
                    }
                  },
                  [
                    _c("label", { attrs: { for: "text2" } }, [
                      _vm._v(" Code ")
                    ]),
                    _vm._v(" "),
                    _c("j-input", {
                      attrs: { id: "text2", placeholder: "Code" },
                      model: {
                        value: _vm.$v.company_location.code.$model,
                        callback: function($$v) {
                          _vm.$set(_vm.$v.company_location.code, "$model", $$v)
                        },
                        expression: "$v.company_location.code.$model"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  {
                    class: {
                      "error-input": _vm.$v.company_location.type.$error
                    }
                  },
                  [
                    _c("label", { attrs: { for: "text3" } }, [
                      _vm._v(" Type ")
                    ]),
                    _vm._v(" "),
                    _c("j-single-select", {
                      attrs: {
                        options: _vm.typeOptions,
                        placeholder: "Select Type",
                        "value-format": "object"
                      },
                      model: {
                        value: _vm.$v.company_location.type.$model,
                        callback: function($$v) {
                          _vm.$set(_vm.$v.company_location.type, "$model", $$v)
                        },
                        expression: "$v.company_location.type.$model"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  {
                    class: {
                      "error-input":
                        _vm.$v.company_location.pic_organigram.$error
                    }
                  },
                  [
                    _c("label", [_vm._v("PIC Position")]),
                    _vm._v(" "),
                    _c("j-single-select", {
                      attrs: {
                        "is-async": true,
                        "load-options": _vm.loadPositionOptions,
                        placeholder: "Select PIC",
                        "value-format": "object",
                        label: "name"
                      },
                      model: {
                        value: _vm.$v.company_location.pic_organigram.$model,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.$v.company_location.pic_organigram,
                            "$model",
                            $$v
                          )
                        },
                        expression: "$v.company_location.pic_organigram.$model"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _vm.mode === "edit"
                      ? _c(
                          "b-button",
                          {
                            staticClass: "btn red",
                            on: { click: _vm.deleteLocation }
                          },
                          [_vm._v("\n            Delete\n          ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "float-right" },
                      [
                        _c(
                          "b-button",
                          { staticClass: "btn", on: { click: _vm.closeModal } },
                          [_vm._v("\n              Cancel\n            ")]
                        ),
                        _vm._v(" "),
                        _vm.mode === "edit"
                          ? _c(
                              "b-button",
                              {
                                staticClass: "btn blue",
                                on: { click: _vm.updateLocation }
                              },
                              [_vm._v("\n              Update\n            ")]
                            )
                          : _c(
                              "b-button",
                              {
                                staticClass: "btn blue",
                                on: { click: _vm.submit }
                              },
                              [_vm._v("\n              Add\n            ")]
                            )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44e266d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44e266d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/location/jFormCompanyLocation.vue
// module id = null
// module chunks = 